<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Forms"
                    />
                    <!-- End Title -->
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('forms', 'view')">
                <app-table v-if="forms.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Name
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(f, i) in forms" :key="i">
                            <app-table-cell>
                                {{ f.name }}
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'forms.edit', params: { handle: f.handle } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('forms', 'edit')">
                                    <app-icon icon="edit" />
                                </router-link>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';

    /* Mixins */
    import Query from '@/mixins/query';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'groups.home',

        data: () => ({
            loading: true,
            forms: [],
            response: null
        }),

        mixins: [ Query, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button
        },

        mounted() {
            this.get().then(response => {
                this.loading = false;
            });
        },

        methods: {
            get() {
                let params = {};

                return Api.request('get', `forms`)
                    .then(({ data }) => {
                        this.forms = data.forms;
                        this.response = data;
                    });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/forms/Home.vue